
<spike-editable-panel 
  title="Informazioni generali" 
  [(isEditing)]="formView"
  [isInsert]="isInsertForm()"
  [isReadonly]="isReadOnly()"
  (onSave)="save()">
    <spike-order-general-form [form]="form"></spike-order-general-form>
    
    <spike-label label="Posizioni" icon="pi pi-list" class="mb-3 block"></spike-label>
    @if(positionReady()){
    <spike-order-positions-form 
      [form]="positionArray"
      (addRow)="addPositionRow()"
      (deleteRow)="deletePositionRow($event)"
      (selectRow)="selectPosition($event)">
    </spike-order-positions-form>
    }
  

</spike-editable-panel>
